import { render, staticRenderFns } from "./DistressalertssitrepFormHeader.vue?vue&type=template&id=5e098516"
import script from "./DistressalertssitrepFormHeader.vue?vue&type=script&lang=js"
export * from "./DistressalertssitrepFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports